module.exports = __webpack_public_path__ + "img/img-multisucursal.44a0f39f.png";